export const colors = {
  nodeBorderColor: '#90CFFD',
  selectedNodeBorderColor: '#40A6FE',
  nodeColor: '#E7F7FE',
  selectedNodeColor: '#94D5FD',
  edgeColor: '#AAB7C4',
  selectedEdgeColor: '#40A6FE'
}


export const selectedNodeStyle = { fill: colors.selectedNodeColor, stroke: colors.selectedNodeBorderColor }
export const nodeStyle = { fill: colors.nodeColor, stroke: colors.nodeBorderColor }
export const edgeStyle = { stroke: colors.edgeColor }
export const selectedEdgeStyle = { stroke: colors.selectedEdgeColor }
